$(document).ready(function() {
  // Cookies
  //cookie create function
  function createCookie(name,value,days) {
      if (days) {
          var date = new Date();
          date.setTime(date.getTime()+(days*24*60*60*1000));
          var expires = "; expires="+date.toGMTString();
      }
      else var expires = "";
      document.cookie = name+"="+value+expires+"; path=/";
  }
  //cookie read function
  function readCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return null;
  }
  
  
  
  if( readCookie("redirect_cookie") == "no") {
    $('.redirect-popup').addClass('hide');
  }
  
  var geoip_request_url = 'https://api.ipbase.com/json/?apikey=clqvsm3p3YxHKCtL9n10fupNWq1PbDbIM77iW1Pr';
  $.getJSON(geoip_request_url, function (ipData) {        
    //console.log(ipData);
    var countryCode = ipData.country_code;
    if(countryCode == 'AU' || countryCode == 'HK'){ 
      if(countryCode == 'HK'){
        var storeUrl = 'hk.dimplecontacts.com';
        var storeUrlText = 'hk.dimplecontacts.com';
        var imgSrc = $('.map-icon').data('hk-src');
      } else {        
        var storeUrl = 'www.dimplecontacts.com';        
        var storeUrlText = 'dimplecontacts.com';
        var imgSrc = $('.map-icon').data('au-src');
      }

      $('.map-icon').attr('src', imgSrc);
      $('.redirect-popup .country').text(ipData.country_name);
      $('#countdown strong, .popup-btn-wrap a').text(storeUrlText);
      $('.popup-btn-wrap a').attr('href', 'https://' + storeUrl);
      $('.redirect-popup').removeClass('hide-popup');

      var timeleft = 5;
      var redirect_cookie = readCookie("redirect_cookie");

      var downloadTimer = setInterval(function(){
        if(timeleft <= 0){
          clearInterval(downloadTimer);
          if(redirect_cookie != 'no') {
            window.location.replace('https://' + storeUrl);
            $('#countdown').text('Redirecting');
          }
        } else {
          $('#countdown span').text(timeleft);
        }
        timeleft -= 1;
      }, 1000);

      $(document).on('click', '.nothankyou', function(){
        createCookie('redirect_cookie', 'no', 1);
        $('.redirect-popup').addClass('hide');
        clearInterval(downloadTimer);
      });
    }
  });
  
});